module.exports = __webpack_public_path__ + "d0e01abef7821fc42095533fa68dd9cd.svg";